import React, { useState } from 'react';

function TallerQF() {
  const [categoriaAbierta, setCategoriaAbierta] = useState('');

  const toggleCategoria = (categoria) => {
    if (categoria === categoriaAbierta) {
      setCategoriaAbierta(''); 
    } else {
      setCategoriaAbierta(categoria); 
    }
  };

  return (
    <div className="constantes-container">

{/* Graficas y MRU-MRUA */}
<div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'MRU-MRUA' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('MRU-MRUA')}
        >
          <h3> Graficas y MRUA</h3>
          <span className={`flecha${categoriaAbierta === 'MRU-MRUA' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'MRU-MRUA' && (
          <div className="categoria-contenido">
            <img src="/1Cap_Graficas_MRU_MRUA.jpg" style={{ width: '1150px' }} />
          </div>
        )}
      </div>

      {/* Resumen Tiro Parabólico */}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'tiroParabolico' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('tiroParabolico')}
        >
          <h3> Resumen Tiro Parabólico</h3>
          <span className={`flecha${categoriaAbierta === 'tiroParabolico' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'tiroParabolico' && (
          <div className="categoria-contenido">
            <img src="/imagen_categoriaTiro1.png" style={{ width: '700px' }} />
          </div>
        )}
      </div>

      {/* Ejercicios de Tiro Parabólico*/}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'ejercicios-parabolico' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('ejercicios-parabolico')}
        >
          <h3>Ejercicios de Tiro Parabólico</h3>
          <span className={`flecha${categoriaAbierta === 'ejercicios-parabolico' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'ejercicios-parabolico' && (
          <div className="categoria-contenido">
            <img src="/2Cap_TiroParabolico.jpg" style={{ width: '1150px' }} />
          </div>
        )}
      </div>

      {/* Leyes de Newton */}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'leyesNewton' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('leyesNewton')}
        >
          <h3>Ejercicios de Leyes de Newton</h3>
          <span className={`flecha${categoriaAbierta === 'leyesNewton' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'leyesNewton' && (
          <div className="categoria-contenido">
            <img src="./3Cap_Leyes_Newton.jpg" style={{ width: '1150px' }} />
        </div>
        )}
      </div>

      {/*Ejercicios de Trabajo y Energía */}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'TrabajoEnergia' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('TrabajoEnergia')}
        >
          <h3>Ejercicios de Trabajo y Energía</h3>
          <span className={`flecha${categoriaAbierta === 'TrabajoEnergia' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'TrabajoEnergia' && (
          <div className="categoria-contenido">
            <img src="./4Cap_TrabajoyEnergia.jpg" style={{ width: '1150px' }} />
          </div>
        )}
      </div>

      {/* Fluidos*/}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'fluidos' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('fluidos')}
        >
          <h3>Ejercicios de Fluidos</h3>
          <span className={`flecha${categoriaAbierta === 'fluidos' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'fluidos' && (
          <div className="categoria-contenido">
            <img src="./8Cap_Fluidos.jpg" style={{ width: '1150px' }} />
          </div>
        )}
      </div>

      {/* Termodinamica*/}
          <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'Termodinamica' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('Termodinamica')}
        >
          <h3>Ejercicios de Termodinámica</h3>
          <span className={`flecha${categoriaAbierta === 'Termodinamica' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'Termodinamica' && (
          <div className="categoria-contenido">
            <img src="./10Cap_Termodinamica.jpg" style={{ width: '1150px' }} />
          </div>
        )}
      </div>



    </div>
  );
}

export default TallerQF;
